import $ from 'jquery'
import deviceType from 'scoreboard/components/device-type'

/**
 * Given a DOM Element, returns a jQuery object containing the element used for
 * scrolling dependent on the browser
 * @param {Element} el
 * @returns {jQuery}
 */
function scrollContainer(el) {
    el = $(el)
    if (!el.hasClass('display-pane-body')) {
        let paneBody = el.find('.display-pane-body')
        if (paneBody.length === 1) {
            // #21939 if there's a display-pane descendant, start looking for the
            // scroll-container from there; if not, just start from the provided element
            el = paneBody
        }
    }
    let selector = deviceType.trident ? '.table-hack-cell' : '.scroll-container'
    return el.find(selector)
}

export default scrollContainer

scrollContainer.__filename__ = 'components/scroll-container.js'
